import React from "react";
import Seo from "../components/Seo";
import Footer from "../components/Footer";
import Hero from "../components/Heros/HeroBusiness";
import Cta from "../components/Cta";
import Feature from "../components/Features/FeatureAgentforce";


const AgentForce = () => (
    <>
        <Seo
            title="Salesforce Agentforce"
            description="Salesforce 플랫폼에서 맞춤형 AI 에이전트를 구축합니다. 사람·AI·데이터·업무를 결합해 고객 서비스와 영업 업무를 자율적으로 처리합니다."
            path="/agent"
        />
        <Hero />
        <Feature />
        <Cta preset="contact" product="Agentforce" />
        <Footer />
    </>
);

export default AgentForce;
